var Haiku = require("@haiku/core");
module.exports = {
  metadata: {
    version: "0.0.11",
    username: "taylor+taylor@haiku.ai",
    organization: "taylor",
    project: "workflowstate",
    branch: "master",
    folder: "/Users/taylorpoe/.haiku/projects/taylor/workflowstate",
    uuid: "8eeae95e-0056-471a-a4d2-9eca3a45acf7",
    root: "https://cdn.haiku.ai/8d91000c-28ac-4bb3-a471-14615fbb8861/38dd9769fb9ba73d1a6c2159dbc4fc570c8a43ab/",
    core: "4.3.1",
    title: "Haikulogo",
    type: "haiku",
    relpath: "code/haikulogo/code.js"
  },
  options: {},
  states: {},
  eventHandlers: {
    "haiku:Haikulogo-c64f35be126e5a1d": {
      sail: {
        handler: function(component, element, target, event) {
          this.getDefaultTimeline().gotoAndPlay(3);
        }
      },
      "timeline:Default:0": {
        handler: function(component, element, target, event) {
          this.getDefaultTimeline().pause();
        }
      },
      "timeline:Default:1": {
        handler: function(component, element, target, event) {
          this.getDefaultTimeline().pause();
        }
      },
      "timeline:Default:79": {
        handler: function(component, element, target, event) {
          this.getDefaultTimeline().pause();
          this.send("up", "sailed");
        }
      },
      "timeline:Default:2": {
        handler: function(component, element, target, event) {
          this.getDefaultTimeline().pause();
        }
      }
    }
  },
  timelines: {
    Default: {
      "haiku:Stop-6c436ddd002d49f7": { stopColor: "#D62563", offset: "100%" },
      "haiku:Stop-6b8d94bf4e76bd9b": { stopColor: "#FFDE64", offset: "0%" },
      "haiku:Haikulogo-c64f35be126e5a1d": {
        "style.WebkitTapHighlightColor": "rgba(0,0,0,0)",
        "style.position": "relative",
        "style.overflowX": "visible",
        "style.overflowY": "visible",
        "sizeAbsolute.x": 226,
        "sizeAbsolute.y": 260,
        "sizeMode.x": 1,
        "sizeMode.y": 1,
        "sizeMode.z": 1
      },
      "haiku:Oval-10-Copy-d80cf3bd83703d06": {
        "translation.y": 147,
        "style.overflow": "visible",
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "translation.x": 113,
        "style.position": "absolute",
        "sizeAbsolute.x": 226,
        "sizeMode.x": 1,
        "sizeAbsolute.y": 226,
        "sizeMode.y": 1,
        "style.zIndex": 3
      },
      "haiku:linearGradient-1-f1658e-1ed1e35b3159fad4": {
        x1: "50%",
        y1: "0%",
        x2: "50%",
        y2: "100%"
      },
      "haiku:Stop-d6ddb9f484fdc387": { stopColor: "#FFDE64", offset: "0%" },
      "haiku:Stop-9ecc2e3b96e308d9": { stopColor: "#D62563", offset: "100%" },
      "haiku:linearGradient-2-f1658e-f711baff829a03a8": {
        x1: "50%",
        y1: "0%",
        x2: "50%",
        y2: "75.2885207%"
      },
      "haiku:Stop-c97a24d37039d24d": { stopColor: "#FEDD64", offset: "0%" },
      "haiku:Stop-bd085ebf90144a94": { stopColor: "#FCD264", offset: "100%" },
      "haiku:linearGradient-3-f1658e-01907fce2727e4b0": {
        x1: "50%",
        y1: "-10.2649741%",
        x2: "50%",
        y2: "165.831298%"
      },
      "haiku:Stop-365757c1e50c4f1d": { stopColor: "#FFDE64", offset: "0%" },
      "haiku:Stop-6548f95211eed488": { stopColor: "#D62563", offset: "100%" },
      "haiku:linearGradient-4-f1658e-53622fc7e838082b": {
        x1: "50%",
        y1: "-5.20911154%",
        x2: "50%",
        y2: "100%"
      },
      "haiku:Stop-4ea67edf68a6a362": { stopColor: "#FFDE64", offset: "0%" },
      "haiku:Stop-8e754301b5325a02": { stopColor: "#D62563", offset: "100%" },
      "haiku:path-5-f1658e-8a600f-7a6f2a065abca7a9": {
        d:
          "M113,268 C175.408177,268 226,217.408177 226,155 C226,92.5918233 175.408177,42 113,42 C50.5918233,42 0,92.5918233 0,155 C0,217.408177 50.5918233,268 113,268 Z"
      },
      "haiku:mask-6-f1658e-8a600f-bf7d04c5da42852c": {
        maskContentUnits: "userSpaceOnUse",
        maskUnits: "objectBoundingBox",
        x: 0,
        y: 0,
        width: 226,
        height: 226,
        fill: "white"
      },
      "haiku:Use-b990de15857e313d": { "xlink:href": "#path-5-f1658e-8a600f" },
      "haiku:Group-ea508bb68ee7fc19": {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd",
        "translation.y": -42
      },
      "haiku:Oval-10-Copy-190b343c79fac290": {
        stroke: "#8D989A",
        mask: "url(#mask-6-f1658e-8a600f)",
        strokeWidth: 2,
        strokeDasharray: "6,11",
        fillRule: "nonzero",
        "xlink:href": "#path-5-f1658e-8a600f"
      },
      "haiku:Line-10-Copy-10-f7ad3114fbadfa8c": {
        "translation.y": 12.63,
        "style.overflow": "visible",
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "translation.x": 112,
        "style.position": "absolute",
        "sizeAbsolute.x": 1,
        "sizeMode.x": 1,
        "sizeAbsolute.y": 39.74045944213867,
        "sizeMode.y": 1,
        "style.zIndex": 4
      },
      "haiku:linearGradient-1-f1658e-567d794e2f5ae4f3": {
        x1: "50%",
        y1: "0%",
        x2: "50%",
        y2: "100%"
      },
      "haiku:Stop-1809ffb1f05afef6": { stopColor: "#D62563", offset: "100%" },
      "haiku:linearGradient-2-f1658e-9cd9ab50eac6edf8": {
        x1: "50%",
        y1: "0%",
        x2: "50%",
        y2: "75.2885207%"
      },
      "haiku:Stop-5296b6c9915c4537": { stopColor: "#FEDD64", offset: "0%" },
      "haiku:Stop-9a4e50e617d9ccad": { stopColor: "#FCD264", offset: "100%" },
      "haiku:linearGradient-3-f1658e-b866044fb1369b97": {
        x1: "50%",
        y1: "-10.2649741%",
        x2: "50%",
        y2: "165.831298%"
      },
      "haiku:Stop-58381dc1ce1f1d5f": { stopColor: "#FFDE64", offset: "0%" },
      "haiku:Bolt-e2393628a82cc5ea": {
        "style.margin": "0",
        "sizeMode.y": 1,
        "style.padding": "0",
        "style.border": "0",
        "sizeAbsolute.x": 10,
        "sizeMode.x": 1,
        "sizeAbsolute.y": 1,
        "style.position": "absolute",
        "translation.x": 111.5,
        "translation.y": {
          "0": { value: 5, edited: true },
          "50": { value: 5, edited: true, curve: "linear" },
          "117": { value: 30, edited: true },
          "1217": { value: 30, edited: true, curve: "linear" },
          "1317": { value: 5, edited: true }
        },
        "style.zIndex": 1,
        "rotation.z": 1.571,
        "translation.z": 0,
        opacity: {
          "0": { value: 0, edited: true },
          "50": { value: 1, edited: true },
          "100": { value: 0, edited: true },
          "1217": { value: 1, edited: true },
          "1317": { value: 0, edited: true }
        }
      },
      "haiku:linearGradient-4-f1658e-76e404cb262c5d2d": {
        x1: "50%",
        y1: "-5.20911154%",
        x2: "50%",
        y2: "100%"
      },
      "haiku:Stop-7d769eb4e3f8d551": { stopColor: "#FFDE64", offset: "0%" },
      "haiku:Stop-bec6d43e31ecc49b": { stopColor: "#D62563", offset: "100%" },
      "haiku:path-5-f1658e-3ead95-3213695cc6f4f117": {
        d:
          "M113,268 C175.408177,268 226,217.408177 226,155 C226,92.5918233 175.408177,42 113,42 C50.5918233,42 0,92.5918233 0,155 C0,217.408177 50.5918233,268 113,268 Z"
      },
      "haiku:mask-6-f1658e-d6173a5304fe8248": {
        maskContentUnits: "userSpaceOnUse",
        maskUnits: "objectBoundingBox",
        x: 0,
        y: 0,
        width: 226,
        height: 226,
        fill: "white"
      },
      "haiku:Use-7819935b290f6c77": { "xlink:href": "#path-5-f1658e-3ead95" },
      "haiku:Group-982e02509b0c67fe": {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd",
        "translation.x": -111.5,
        "translation.y": -0.76
      },
      "haiku:Line-10-Copy-10-1e45f624d3cfbf70": {
        d: "M111.5,40.5 L111.5,0.759541",
        stroke: "#8F9A9C",
        strokeLinecap: "square",
        strokeDasharray: "4,10",
        fillRule: "nonzero"
      },
      "haiku:Bolt-Circle-52429da574754a66": {
        "style.position": "absolute",
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "sizeAbsolute.x": 226,
        "sizeMode.x": 1,
        "sizeAbsolute.y": 226,
        "sizeMode.y": 1,
        "translation.x": {
          "0": { value: 113, edited: true },
          "717": { value: 113 }
        },
        "translation.y": {
          "0": { value: 146.5, edited: true },
          "717": { value: 146.5 }
        },
        "style.zIndex": 2,
        "rotation.z": {
          "0": { value: 0, edited: true },
          "100": { value: 0, edited: true, curve: "linear" },
          "1217": { value: -6.007, edited: true }
        },
        "translation.z": {
          "0": { value: 0, edited: true },
          "717": { value: 0 }
        },
        opacity: {
          "0": { value: 0, edited: true },
          "100": { value: 1, edited: true },
          "1217": { value: 0, edited: true }
        }
      },
      "haiku:Page-1-761d9b43735e66b0": {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      },
      "haiku:Artboard-72bd784aff225c7b": {
        fill: "#00E5FD",
        fillRule: "nonzero",
        "translation.x": -608,
        "translation.y": -138
      },
      "haiku:Thang-b549d00fb13a73ca": {
        "translation.x": 2,
        "translation.y": -4
      },
      "haiku:Bolt-d495bff481159a63": {
        x: 606.452681,
        y: 142,
        width: 9.17521084,
        height: 1,
        rx: 0.5
      },
      "haiku:Path-1-641b54-3ce23ea4fad8fb91": {
        d:
          "M113,226 C175.408177,226 226,175.408177 226,113 C226,50.5918233 175.408177,0 113,0 C50.5918233,0 0,50.5918233 0,113 C0,175.408177 50.5918233,226 113,226 Z"
      },
      "haiku:Mask-2-641b54-c86990607357e7a9": {
        maskContentUnits: "userSpaceOnUse",
        maskUnits: "objectBoundingBox",
        x: 0,
        y: 0,
        width: 226,
        height: 226,
        fill: "white"
      },
      "haiku:Use-aff78939e543e963": { "xlink:href": "#path-1-641b54" },
      "haiku:Page-1-19baf964bb49bb39": {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      },
      "haiku:Artboard-45270e0d71ba64b6": {
        fillRule: "nonzero",
        "translation.x": -522,
        "translation.y": -181
      },
      "haiku:Thang-fc773ddc4bdf4d95": {
        "translation.x": 2,
        "translation.y": -4
      },
      "haiku:Bolt-Circle-9ef6b2d938f587ec": {
        "translation.x": 520,
        "translation.y": 185
      },
      "haiku:Oval-10-4af9f0a87d0e4792": {
        strokeOpacity: 0.0514605978,
        stroke: "#8E999B",
        mask: "url(#mask-2-641b54)",
        strokeWidth: 2,
        strokeDasharray: "6,11",
        "xlink:href": "#path-1-641b54"
      },
      "haiku:Rectangle-2-43ea606e706a2536": {
        fill: "#00E5FD",
        x: 86.4526806,
        y: 2.20324058,
        width: 9.17521084,
        height: 1,
        rx: 0.5,
        "translation.x": 1.157,
        "translation.y": 17.421,
        "rotation.z": 6.091
      },
      "haiku:Symbol-3dddbdaee01742df": {
        "sizeMode.x": 1,
        "style.position": "absolute",
        "style.padding": "0",
        "style.border": "0",
        "sizeAbsolute.x": 91,
        "style.margin": "0",
        "sizeAbsolute.y": 101,
        "sizeMode.y": 1,
        "translation.x": 113,
        "translation.y": 147,
        "style.zIndex": 5
      },
      "haiku:Linear-Gradient-1-641b54-f9147ff32b25cad4": {
        x1: "50%",
        y1: "-8.06520239%",
        x2: "50%",
        y2: "92.1099078%"
      },
      "haiku:Stop-df67b7ae29a51ea9": { stopColor: "#FFDE64", offset: "0%" },
      "haiku:Stop-2ef913f3b2be56a6": { stopColor: "#D62563", offset: "100%" },
      "haiku:Page-1-5f0c912890208eec": {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      },
      "haiku:Artboard-2e7d55d28e2c1780": {
        fill: "url(#linearGradient-1-641b54)",
        fillRule: "nonzero",
        "translation.x": -591,
        "translation.y": -247
      },
      "haiku:Symbol-e9a656118ce91c4b": {
        d:
          "M649.828033,300.952073 L649.828033,313.002799 C649.828033,314.530448 648.605175,315.768853 647.096704,315.768853 C646.659728,315.768853 646.24672,315.664932 645.880462,315.480163 C645.823133,315.460241 645.766068,315.438269 645.709351,315.414213 L608.013098,299.426186 C607.471089,299.16888 607.109668,298.846581 606.888464,298.480547 C606.543066,298.03227 606.338244,297.435317 606.338244,296.698843 L606.338244,264.98373 C606.254832,264.876406 606.178072,264.762334 606.108834,264.641885 L604.367749,263.929094 L596.463438,260.693111 L596.463438,336.397574 L606.338244,340.440267 L606.338244,314.997351 C606.338244,314.957771 606.339065,314.918386 606.340691,314.879211 C606.321707,314.480719 606.387944,314.071799 606.550262,313.679296 C607.132976,312.27023 608.733293,311.606344 610.12467,312.196466 L646.992056,327.833981 L648.340897,328.448689 C648.517109,328.528994 648.680812,328.625882 648.831019,328.736716 C649.756538,329.171445 650.249617,329.595637 650.249617,330.91858 L650.249617,336.397574 L660.029372,340.401354 L660.124424,340.440267 L660.124424,296.328498 L649.828033,300.952073 Z M644.365374,302.033495 L624.854635,293.6016 L616.794124,297.003963 L644.365374,308.829954 L644.365374,302.033495 Z M611.800903,318.905075 L611.800903,340.861198 L621.67571,336.818505 L621.67571,323.093254 L611.800903,318.905075 Z M665.587083,340.864529 L675.882094,336.649806 L675.882094,260.847888 L665.587083,265.062611 L665.587083,274.308678 C665.587083,275.181652 665.187753,275.960172 664.563992,276.467116 C664.286034,276.822171 663.917864,277.112912 663.475645,277.299574 L631.954432,290.604758 L646.223859,296.656818 C646.326873,296.60179 646.427518,296.552252 646.524599,296.508786 L661.489427,289.663988 C662.869082,289.046282 664.611058,289.339936 665.302719,290.864585 C665.437854,291.162468 665.511602,291.467683 665.532504,291.770601 C665.568295,292.03994 665.587083,292.348785 665.587083,292.702926 L665.587083,340.864529 Z M660.124424,264.98373 C660.041012,264.876406 659.964251,264.762334 659.895013,264.641885 L658.153928,263.929094 L650.249617,260.693111 L650.249617,267.114952 L660.124424,271.157645 L660.124424,264.98373 Z M646.346533,253.701149 C646.436393,253.652866 646.529589,253.608821 646.625974,253.569361 L661.740285,247.381642 C662.503417,246.948718 663.448543,246.863468 664.317645,247.232736 L679.541304,253.701046 C679.863436,253.837915 680.148892,254.02608 680.392299,254.252237 C680.967352,254.733417 681.344753,255.407229 681.344753,256.23404 L681.344753,256.381473 C681.345769,256.426508 681.345774,256.471646 681.344753,256.516856 L681.344753,338.791194 C681.344753,339.548448 681.112061,340.077394 680.731446,340.478626 C680.482567,340.800602 680.087075,341.088174 679.503979,341.344083 L664.589167,347.574623 C663.815581,347.891325 662.931401,347.906635 662.171823,347.639928 C661.980666,347.604017 661.790205,347.548277 661.602965,347.471622 L657.824539,345.924754 L646.625974,341.340121 C645.744457,340.979233 645.129715,340.234761 644.893525,339.373535 C644.830446,339.151948 644.793985,338.918935 644.787877,338.678277 C644.785984,338.622047 644.785669,338.565635 644.786959,338.509106 L644.786959,332.895501 L644.750334,332.87881 L644.786959,332.79639 L644.786959,332.895377 L627.138368,325.41012 L627.138368,338.768511 C627.138368,338.850854 627.134815,338.932356 627.127856,339.01287 C627.123975,340.18744 626.42977,341.298265 625.288079,341.765667 L610.592195,347.782085 C609.791697,348.109804 608.932325,348.055249 608.211384,347.703187 C608.118118,347.675764 608.025992,347.643567 607.935383,347.606472 L604.367749,346.059605 L592.839794,341.340121 C592.238708,341.094039 591.76166,340.669608 591.44409,340.151424 C591.160563,339.796519 591.000779,339.363338 591.000779,338.791194 L591.000779,338.64575 C590.999743,338.600301 590.999738,338.554742 591.000779,338.509106 L591.000779,256.51524 C590.999825,256.473406 590.999745,256.43148 591.00055,256.389486 C590.999745,256.347492 590.999825,256.305566 591.000779,256.263733 L591.000779,256.23404 C591.000779,255.391339 591.372893,254.636654 591.959794,254.129314 C592.210897,253.897382 592.506249,253.705913 592.839794,253.569361 L607.954105,247.381642 C608.717237,246.948718 609.662363,246.863468 610.531465,247.232736 L625.755125,253.701046 C625.859195,253.745264 625.959437,253.794835 626.055669,253.849312 C626.959089,254.316389 627.558573,255.146059 627.558573,256.233156 L627.558573,256.381473 C627.55959,256.426507 627.559594,256.471645 627.558573,256.516854 L627.558573,274.499275 L644.786959,267.471844 L644.786959,256.51524 C644.786005,256.473406 644.785925,256.43148 644.78673,256.389486 C644.785925,256.347492 644.786005,256.305566 644.786959,256.263733 L644.786959,256.233156 C644.786959,254.545898 645.354184,254.100161 646.346533,253.701149 Z M611.800903,293.118207 L622.095914,288.772657 L622.095914,260.847888 L611.800903,265.062611 L611.800903,293.118207 Z M627.558573,280.463261 L627.558573,286.466854 L654.275977,275.18937 L647.466383,272.401558 C647.442698,272.391862 647.419206,272.381888 647.395909,272.371643 L627.558573,280.463261 Z M655.433911,256.389486 L660.358762,258.405694 L663.254887,259.591352 L670.865535,256.475593 L663.189776,253.214276 L655.433911,256.389486 Z M601.647732,256.389486 L606.572582,258.405694 L609.468707,259.591352 L617.079355,256.475593 L609.403597,253.214276 L601.647732,256.389486 Z"
      }
    }
  },
  template: {
    elementName: "div",
    attributes: {
      "haiku-id": "Haikulogo-c64f35be126e5a1d",
      "haiku-title": "Haikulogo"
    },
    children: [
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Symbol-3dddbdaee01742df",
          "haiku-title": "symbol",
          "haiku-source":
            "designs/workflowstate.sketch.contents/slices/symbol.svg"
        },
        children: [
          {
            elementName: "defs",
            attributes: { "haiku-id": "Defs-79551506c2dae149" },
            children: [
              {
                elementName: "linearGradient",
                attributes: {
                  "haiku-id": "Linear-Gradient-1-641b54-f9147ff32b25cad4",
                  id: "linearGradient-1-641b54"
                },
                children: [
                  {
                    elementName: "stop",
                    attributes: { "haiku-id": "Stop-df67b7ae29a51ea9" },
                    children: []
                  },
                  {
                    elementName: "stop",
                    attributes: { "haiku-id": "Stop-2ef913f3b2be56a6" },
                    children: []
                  }
                ]
              }
            ]
          },
          {
            elementName: "g",
            attributes: { "haiku-id": "Page-1-5f0c912890208eec", id: "Page-1" },
            children: [
              {
                elementName: "g",
                attributes: {
                  "haiku-id": "Artboard-2e7d55d28e2c1780",
                  id: "Artboard"
                },
                children: [
                  {
                    elementName: "path",
                    attributes: {
                      "haiku-id": "Symbol-e9a656118ce91c4b",
                      id: "symbol"
                    },
                    children: []
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Bolt-Circle-52429da574754a66",
          "haiku-title": "bolt_circle",
          "haiku-source":
            "designs/workflowstate.sketch.contents/slices/bolt_circle.svg"
        },
        children: [
          {
            elementName: "defs",
            attributes: { "haiku-id": "Defs-78f4209d6bfa924f" },
            children: [
              {
                elementName: "path",
                attributes: {
                  "haiku-id": "Path-1-641b54-3ce23ea4fad8fb91",
                  id: "path-1-641b54"
                },
                children: []
              },
              {
                elementName: "mask",
                attributes: {
                  "haiku-id": "Mask-2-641b54-c86990607357e7a9",
                  id: "mask-2-641b54"
                },
                children: [
                  {
                    elementName: "use",
                    attributes: { "haiku-id": "Use-aff78939e543e963" },
                    children: []
                  }
                ]
              }
            ]
          },
          {
            elementName: "g",
            attributes: { "haiku-id": "Page-1-19baf964bb49bb39", id: "Page-1" },
            children: [
              {
                elementName: "g",
                attributes: {
                  "haiku-id": "Artboard-45270e0d71ba64b6",
                  id: "Artboard"
                },
                children: [
                  {
                    elementName: "g",
                    attributes: {
                      "haiku-id": "Thang-fc773ddc4bdf4d95",
                      id: "thang"
                    },
                    children: [
                      {
                        elementName: "g",
                        attributes: {
                          "haiku-id": "Bolt-Circle-9ef6b2d938f587ec",
                          id: "bolt_circle"
                        },
                        children: [
                          {
                            elementName: "use",
                            attributes: {
                              "haiku-id": "Oval-10-4af9f0a87d0e4792",
                              id: "Oval-10"
                            },
                            children: []
                          },
                          {
                            elementName: "rect",
                            attributes: {
                              "haiku-id": "Rectangle-2-43ea606e706a2536",
                              id: "Rectangle-2"
                            },
                            children: []
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Line-10-Copy-10-f7ad3114fbadfa8c",
          "haiku-title": "Line-10-Copy-10",
          "haiku-source":
            "designs/workflowstate.sketch.contents/slices/logo_group.svg#Line-10-Copy-10",
          "haiku-locked": true
        },
        children: [
          {
            elementName: "defs",
            attributes: { "haiku-id": "Defs-8d11ac991eaaa4c7" },
            children: [
              {
                elementName: "linearGradient",
                attributes: {
                  "haiku-id": "linearGradient-1-f1658e-567d794e2f5ae4f3",
                  id: "linearGradient-1-f1658e"
                },
                children: [
                  {
                    elementName: "stop",
                    attributes: { "haiku-id": "Stop-6b8d94bf4e76bd9b" },
                    children: []
                  },
                  {
                    elementName: "stop",
                    attributes: { "haiku-id": "Stop-1809ffb1f05afef6" },
                    children: []
                  }
                ]
              },
              {
                elementName: "linearGradient",
                attributes: {
                  "haiku-id": "linearGradient-2-f1658e-9cd9ab50eac6edf8",
                  id: "linearGradient-2-f1658e"
                },
                children: [
                  {
                    elementName: "stop",
                    attributes: { "haiku-id": "Stop-5296b6c9915c4537" },
                    children: []
                  },
                  {
                    elementName: "stop",
                    attributes: { "haiku-id": "Stop-9a4e50e617d9ccad" },
                    children: []
                  }
                ]
              },
              {
                elementName: "linearGradient",
                attributes: {
                  "haiku-id": "linearGradient-3-f1658e-b866044fb1369b97",
                  id: "linearGradient-3-f1658e"
                },
                children: [
                  {
                    elementName: "stop",
                    attributes: { "haiku-id": "Stop-58381dc1ce1f1d5f" },
                    children: []
                  },
                  {
                    elementName: "stop",
                    attributes: { "haiku-id": "Stop-6c436ddd002d49f7" },
                    children: []
                  }
                ]
              },
              {
                elementName: "linearGradient",
                attributes: {
                  "haiku-id": "linearGradient-4-f1658e-76e404cb262c5d2d",
                  id: "linearGradient-4-f1658e"
                },
                children: [
                  {
                    elementName: "stop",
                    attributes: { "haiku-id": "Stop-7d769eb4e3f8d551" },
                    children: []
                  },
                  {
                    elementName: "stop",
                    attributes: { "haiku-id": "Stop-bec6d43e31ecc49b" },
                    children: []
                  }
                ]
              },
              {
                elementName: "path",
                attributes: {
                  "haiku-id": "path-5-f1658e-3ead95-3213695cc6f4f117",
                  id: "path-5-f1658e-3ead95"
                },
                children: []
              },
              {
                elementName: "mask",
                attributes: {
                  "haiku-id": "mask-6-f1658e-d6173a5304fe8248",
                  id: "mask-6-f1658e"
                },
                children: [
                  {
                    elementName: "use",
                    attributes: { "haiku-id": "Use-7819935b290f6c77" },
                    children: []
                  }
                ]
              }
            ]
          },
          {
            elementName: "g",
            attributes: { "haiku-id": "Group-982e02509b0c67fe" },
            children: [
              {
                elementName: "path",
                attributes: {
                  "haiku-id": "Line-10-Copy-10-1e45f624d3cfbf70",
                  id: "Line-10-Copy-10"
                },
                children: []
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Oval-10-Copy-d80cf3bd83703d06",
          "haiku-title": "Oval-10-Copy",
          "haiku-source":
            "designs/workflowstate.sketch.contents/slices/logo_group.svg#Oval-10-Copy",
          "haiku-locked": true
        },
        children: [
          {
            elementName: "defs",
            attributes: { "haiku-id": "Defs-9bf3e3737f041995" },
            children: [
              {
                elementName: "linearGradient",
                attributes: {
                  "haiku-id": "linearGradient-1-f1658e-1ed1e35b3159fad4",
                  id: "linearGradient-1-f1658e"
                },
                children: [
                  {
                    elementName: "stop",
                    attributes: { "haiku-id": "Stop-d6ddb9f484fdc387" },
                    children: []
                  },
                  {
                    elementName: "stop",
                    attributes: { "haiku-id": "Stop-9ecc2e3b96e308d9" },
                    children: []
                  }
                ]
              },
              {
                elementName: "linearGradient",
                attributes: {
                  "haiku-id": "linearGradient-2-f1658e-f711baff829a03a8",
                  id: "linearGradient-2-f1658e"
                },
                children: [
                  {
                    elementName: "stop",
                    attributes: { "haiku-id": "Stop-c97a24d37039d24d" },
                    children: []
                  },
                  {
                    elementName: "stop",
                    attributes: { "haiku-id": "Stop-bd085ebf90144a94" },
                    children: []
                  }
                ]
              },
              {
                elementName: "linearGradient",
                attributes: {
                  "haiku-id": "linearGradient-3-f1658e-01907fce2727e4b0",
                  id: "linearGradient-3-f1658e"
                },
                children: [
                  {
                    elementName: "stop",
                    attributes: { "haiku-id": "Stop-365757c1e50c4f1d" },
                    children: []
                  },
                  {
                    elementName: "stop",
                    attributes: { "haiku-id": "Stop-6548f95211eed488" },
                    children: []
                  }
                ]
              },
              {
                elementName: "linearGradient",
                attributes: {
                  "haiku-id": "linearGradient-4-f1658e-53622fc7e838082b",
                  id: "linearGradient-4-f1658e"
                },
                children: [
                  {
                    elementName: "stop",
                    attributes: { "haiku-id": "Stop-4ea67edf68a6a362" },
                    children: []
                  },
                  {
                    elementName: "stop",
                    attributes: { "haiku-id": "Stop-8e754301b5325a02" },
                    children: []
                  }
                ]
              },
              {
                elementName: "path",
                attributes: {
                  "haiku-id": "path-5-f1658e-8a600f-7a6f2a065abca7a9",
                  id: "path-5-f1658e-8a600f"
                },
                children: []
              },
              {
                elementName: "mask",
                attributes: {
                  "haiku-id": "mask-6-f1658e-8a600f-bf7d04c5da42852c",
                  id: "mask-6-f1658e-8a600f"
                },
                children: [
                  {
                    elementName: "use",
                    attributes: { "haiku-id": "Use-b990de15857e313d" },
                    children: []
                  }
                ]
              }
            ]
          },
          {
            elementName: "g",
            attributes: { "haiku-id": "Group-ea508bb68ee7fc19" },
            children: [
              {
                elementName: "use",
                attributes: {
                  "haiku-id": "Oval-10-Copy-190b343c79fac290",
                  id: "Oval-10-Copy"
                },
                children: []
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Bolt-e2393628a82cc5ea",
          "haiku-title": "bolt",
          "haiku-source":
            "designs/workflowstate.sketch.contents/slices/bolt.svg"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Page-1-761d9b43735e66b0", id: "Page-1" },
            children: [
              {
                elementName: "g",
                attributes: {
                  "haiku-id": "Artboard-72bd784aff225c7b",
                  id: "Artboard"
                },
                children: [
                  {
                    elementName: "g",
                    attributes: {
                      "haiku-id": "Thang-b549d00fb13a73ca",
                      id: "thang"
                    },
                    children: [
                      {
                        elementName: "rect",
                        attributes: {
                          "haiku-id": "Bolt-d495bff481159a63",
                          id: "bolt"
                        },
                        children: []
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/@haiku/taylor-workflowstate/code/haikulogo/code.js
// module id = 536
// module chunks = 35783957827783